import React, { useEffect, useState } from 'react';
import { useProducts } from './ProductStore';
import { MainTable } from '../../../Components/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import Variations from './Variations/Variations';
import { Modal } from 'antd';

function Products(props) {
    let [varmodal, setVarModal] = useState(false)
    let [varcurrent, setVarCurrent] = useState({})
    let { products, getProducts, columns, setEd, deletePR } = useProducts()
    useEffect(() => {
        getProducts()
    }, [])

    return (
        <>
            <Modal width={'80%'} title="Variatsiyalar" open={varmodal} footer={null} onCancel={()=>setVarModal(false)}>
                <Variations vr={varcurrent} />
            </Modal>
            <MainTable
                pageTitle="Mahsulotlar"
                pcolumns={columns}
                pdata={products}
                add={<Add />}
                edit={<Edit />}
                defkey={'id'}
                onDelete={(_, pr)=>deletePR(pr.id)}
                onEdit={(rec) => setEd(rec)}
                setEd={setEd}
                xwidth={1500}
                adw={'50%'}
                edw={'50%'}
                viewBtn={true}
                onView={(e, rec) => {
                    setVarCurrent(rec)
                    setVarModal(true)
                }}
            />
        </>
    );
}

export default Products;